import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import NotFound from "pages/NotFound";
import LeverancierLogin from './pages/provider-login';
import CustomerRegistration from './pages/customer-registration';
import CustomerLogin from './pages/customer-login';
import LeverancierRegistration from './pages/provider-registration';
import Homepage from './pages/homepage';
import LeverancierDashboard from './pages/provider-dashboard';
import QuoteRequestForm from './pages/quote-request-form';
import InsulationCategoryPage from './pages/insulation-category-page';
import HeatPumpCategoryPage from './pages/heat-pump-category-page';
import SolarPanelCategoryPage from './pages/solar-panel-category-page';
import BatteryStorageCategoryPage from './pages/battery-storage-category-page';
import VentilationCategoryPage from './pages/ventilation-category-page';
import WaterSoftenerCategoryPage from './pages/water-softener-category-page';
import LeveranciersOverviewPage from './pages/providers-overview-page';
import SustainabilityKnowledgeHub from './pages/sustainability-knowledge-hub';
import CRMDashboardOverview from './pages/crm-dashboard-overview';
import QuoteManagementSystem from './pages/quote-management-system';
import CustomerRelationshipManager from './pages/customer-relationship-manager';
import SalesAgentRegistration from './pages/sales-agent-registration';
import ResellerRegistration from './pages/reseller-registration';

import SalesAgentDashboard from './pages/sales-agent-dashboard';
import ResellerDashboard from './pages/reseller-dashboard';
import SalesAgentCRMDashboard from './pages/sales-agent-crm-dashboard';
import ResellerCRMDashboard from './pages/reseller-crm-dashboard';
import SalesAgentLogin from './pages/sales-agent-login';
import ResellerLogin from './pages/reseller-login';
import ProviderProductManagement from './pages/provider-product-management';
import ProviderReviewManagement from './pages/provider-review-management';
import ProviderNewsUpdatesCenter from './pages/provider-news-updates-center';
import ProviderProfilePage from './pages/provider-profile-page';
import CostsAndPaybackPeriodGuide from './pages/costs-and-payback-period-guide';
import SubsidiesAndRegulationsHub from './pages/subsidies-and-regulations-hub';
import CommonMistakesGuide from './pages/common-mistakes-guide';
import DecisionGuides from './pages/decision-guides';
import GRPThuisbatterijen from './pages/grp-thuisbatterijen';
import PrivacyPage from './pages/privacy';
import VoorwaardenPage from './pages/voorwaarden';
import TransparantiePage from './pages/transparantie';
import OverOnsPage from './pages/over-ons';
import OnzeMissiePage from './pages/onze-missie';
import OnafhankelijkheidPage from './pages/onafhankelijkheid';
import WerkwijzePage from './pages/werkwijze';
import ContactPage from './pages/contact';
import CarrierePage from './pages/carriere';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/leverancier-login" element={<LeverancierLogin />} />
          <Route path="/sales-agent-login" element={<SalesAgentLogin />} />
          <Route path="/reseller-login" element={<ResellerLogin />} />
          <Route path="/customer-registration" element={<CustomerRegistration />} />
          <Route path="/customer-login" element={<CustomerLogin />} />
          <Route path="/leverancier-registration" element={<LeverancierRegistration />} />
          <Route path="/sales-agent-registration" element={<SalesAgentRegistration />} />
          <Route path="/reseller-registration" element={<ResellerRegistration />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/leverancier-dashboard" element={<LeverancierDashboard />} />
          <Route path="/sales-agent-dashboard" element={<SalesAgentDashboard />} />
          <Route path="/reseller-dashboard" element={<ResellerDashboard />} />
          <Route path="/sales-agent-crm" element={<SalesAgentCRMDashboard />} />
          <Route path="/reseller-crm" element={<ResellerCRMDashboard />} />
          <Route path="/provider-product-management" element={<ProviderProductManagement />} />
          <Route path="/provider-review-management" element={<ProviderReviewManagement />} />
          <Route path="/provider-news-updates-center" element={<ProviderNewsUpdatesCenter />} />
          <Route path="/provider-profile/:providerId" element={<ProviderProfilePage />} />
          <Route path="/costs-and-payback-period-guide" element={<CostsAndPaybackPeriodGuide />} />
          <Route path="/subsidies-and-regulations-hub" element={<SubsidiesAndRegulationsHub />} />
          <Route path="/knowledge/mistakes" element={<CommonMistakesGuide />} />
          <Route path="/knowledge/guides" element={<DecisionGuides />} />
          <Route path="/grp-batterij" element={<GRPThuisbatterijen />} />
          <Route path="/grp-thuisbatterijen" element={<GRPThuisbatterijen />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/voorwaarden" element={<VoorwaardenPage />} />
          <Route path="/terms" element={<VoorwaardenPage />} />
          <Route path="/transparantie" element={<TransparantiePage />} />
          <Route path="/transparency" element={<TransparantiePage />} />
          <Route path="/over-ons" element={<OverOnsPage />} />
          <Route path="/onze-missie" element={<OnzeMissiePage />} />
          <Route path="/about" element={<OnzeMissiePage />} />
          <Route path="/onafhankelijkheid" element={<OnafhankelijkheidPage />} />
          <Route path="/about/independence" element={<OnafhankelijkheidPage />} />
          <Route path="/werkwijze" element={<WerkwijzePage />} />
          <Route path="/how-it-works" element={<WerkwijzePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/carriere" element={<CarrierePage />} />
          <Route path="/careers" element={<CarrierePage />} />
          <Route path="/quote-request-form" element={<QuoteRequestForm />} />
          <Route path="/insulation-category-page" element={<InsulationCategoryPage />} />
          <Route path="/services/insulation" element={<InsulationCategoryPage />} />
          <Route path="/heat-pump-category-page" element={<HeatPumpCategoryPage />} />
          <Route path="/services/heatpump" element={<HeatPumpCategoryPage />} />
          <Route path="/solar-panel-category-page" element={<SolarPanelCategoryPage />} />
          <Route path="/services/solar" element={<SolarPanelCategoryPage />} />
          <Route path="/battery-storage-category-page" element={<BatteryStorageCategoryPage />} />
          <Route path="/services/battery" element={<BatteryStorageCategoryPage />} />
          <Route path="/ventilation-category-page" element={<VentilationCategoryPage />} />
          <Route path="/services/ventilation" element={<VentilationCategoryPage />} />
          <Route path="/water-softener-category-page" element={<WaterSoftenerCategoryPage />} />
          <Route path="/services/water-softener" element={<WaterSoftenerCategoryPage />} />
          <Route path="/leveranciers" element={<LeveranciersOverviewPage />} />
          <Route path="/sustainability-knowledge-hub" element={<SustainabilityKnowledgeHub />} />
          <Route path="/knowledge" element={<SustainabilityKnowledgeHub />} />
          <Route path="/crm-dashboard-overview" element={<CRMDashboardOverview />} />
          <Route path="/quote-management-system" element={<QuoteManagementSystem />} />
          <Route path="/customer-relationship-manager" element={<CustomerRelationshipManager />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
